import { DSText } from '@engenharia/ds-react';
import styled from 'styled-components';
import spaces from '../../../styles/theme/spaces';
import colors from '../../../styles/theme/colors';
import { sizes } from '../../../styles/theme/devices';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: auto;

  header {
    position: sticky;
    top: 0;
  }

  footer {
    position: sticky;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 ${spaces.small};
  background: linear-gradient(135deg, #ef9f2e 37.83%, #e02b4b 100%);
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '729px'};
  padding: 0;
  border-radius: 16px;
  background: ${colors.default.white};

  max-height: calc(100vh - 200px);
  overflow-y: ${({ $allowOverflow }) => ($allowOverflow ? 'visible' : 'auto')};
  overflow-x: ${({ $allowOverflow }) => ($allowOverflow ? 'visible' : 'hidden')};

  padding: 0;

  &::-webkit-scrollbar {
    width: 14px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-200);
    border-radius: 16px;
    width: 6px;
    border: 4px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }
`;

const BoxContent = styled.div`
  padding: ${spaces.xs};
  overflow: ${({ $allowOverflow }) => ($allowOverflow ? 'visible' : 'initial')};

  @media (min-width: ${sizes.tablet}) {
    padding: 24px;
  }
`;

const StepsWrapper = styled.div`
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  background: ${colors.gray[50]};
  border-radius: 16px 16px 0 0;
`;

const Heading = styled(DSText)`
  color: ${colors.gray[800]};
  font-weight: 600;
  text-align: center;
  font-size: 20px;
  margin-bottom: ${spaces.small};
  width: 100%;
  line-height: 1.4;

  @media (min-width: ${sizes.tablet}) {
    line-height: 1.8;
  }
`;

export { Box, BoxContent, StepsWrapper, Container, Content, Heading };
